module.exports = __webpack_public_path__ + "static/media/settingsdark.cef302da.svg";